/**
 * @generated SignedSource<<fb019d2035e43ef7aeaf911d473d58c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useStripeCheckoutRedirectMutation$variables = {
  billingPeriod: string;
  redirectUrl?: string | null;
};
export type useStripeCheckoutRedirectMutation$data = {
  readonly createStripeCheckoutSession: {
    readonly url: string | null;
  } | null;
};
export type useStripeCheckoutRedirectMutation = {
  response: useStripeCheckoutRedirectMutation$data;
  variables: useStripeCheckoutRedirectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billingPeriod"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redirectUrl"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "billingPeriod",
        "variableName": "billingPeriod"
      },
      {
        "kind": "Variable",
        "name": "redirectUrl",
        "variableName": "redirectUrl"
      }
    ],
    "concreteType": "CreateStripeCheckoutSessionMutation",
    "kind": "LinkedField",
    "name": "createStripeCheckoutSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useStripeCheckoutRedirectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStripeCheckoutRedirectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab8ac42a1df691bd22d48744cbfcfa5f",
    "id": null,
    "metadata": {},
    "name": "useStripeCheckoutRedirectMutation",
    "operationKind": "mutation",
    "text": "mutation useStripeCheckoutRedirectMutation(\n  $billingPeriod: String!\n  $redirectUrl: String\n) {\n  createStripeCheckoutSession(billingPeriod: $billingPeriod, redirectUrl: $redirectUrl) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ff34264c68e2453bf49ad0f72d14ab4";

export default node;
